import React from 'react';
import { Popover } from 'antd';
import { IBook } from '../../../section/Common/types/types';
import { ACTIONS, useActions } from '../../../context/Actions.context';
import { GAEventName } from '../../../section/Common/constants';
import { ReactComponent as UnmuteIcon } from '../../../assets/icons/bell-off-fill-unmute.svg';

interface IProps {
  book: IBook;
  id: string;
  label?: string;
}

const UnmuteAuthor: React.FC<IProps> = ({ book, id, label = 'Author' }) => {
  const { setAction } = useActions();

  return (
    <Popover
      placement='topLeft'
      content={
        <div className='popover-content'>
          {`Unmute ${label}`}
        </div>
      }
      trigger='hover'
    >
      <UnmuteIcon
        data-testid='action-unmute-author'
        onClick={(e) => {
          e.stopPropagation();

          window.gtag('event', GAEventName.click, {
            identifier: ACTIONS.unmuteAuthor,
            value: book.Author
          });

          setAction({
            book,
            id,
            type: ACTIONS.unmuteAuthor
          });
        }}
        className='actions-icons actions-icons-unmute'
      />
    </Popover>
  );
};

export default React.memo(UnmuteAuthor);